export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_URL;
export const SSO_API_BASE_URL = process.env.REACT_APP_SSO_API_BASE_URL;

// SSO token refresh endpoint (relative to SSO_API_BASE_URL).
export const SSO_REFRESH_TOKEN = "/v1.2/auth/refresh";

// Content endpoint: authenticated API that serves MDX/MD content from blob storage.
// Unused for now (MDX stays bundled). TODO(Part 2).
export const CONTENT = "/api/v1/content";
